import { defineNuxtPlugin } from '#app';

import { runGpuTierProbe } from '~/composables/useGpuTier';

export default defineNuxtPlugin(() => {
    void runGpuTierProbe();
});
